import React from "react";
import Table from "../../ui/Table";
import StatusBadge from "../../ui/StatusBadge";
import { formatKpiValueWithUnit } from "../../utils/kpiUnits";

export default function KpiMeasurementsTable({ measurements = [], unit = null }) {
  const columns = [
    {
      id: "date",
      header: "Date",
      accessor: (row) => new Date(row.measured_at || row.created_at).toLocaleString(),
    },
    { id: "value", header: "Value", accessor: (row) => formatKpiValueWithUnit(row.value, unit) },
    { id: "source", header: "Source", accessor: (row) => row.source || "manual" },
    {
      id: "status",
      header: "Status",
      accessor: (row) =>
        row.approved ? (
          <StatusBadge variant="status" value="completed" label="Approved" />
        ) : (
          <StatusBadge variant="status" value="pending" />
        ),
    },
    { id: "note", header: "Note", accessor: (row) => row.note || "-" },
  ];

  return (
    <Table
      columns={columns}
      data={measurements}
      getRowKey={(row) => row.id}
      emptyState="No measurements yet."
    />
  );
}
